import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "block" }
const _hoisted_2 = { class: "title" }

import { PropType } from 'vue';
  import { useAppStore } from '@/store';
  import FormWrapper from './form-wrapper.vue';

  interface OptionsProps {
    name: string;
    key: string;
    type?: string;
    defaultVal?: boolean | string | number;
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'block',
  props: {
    title: {
      type: String,
      default: '',
    },
    options: {
      type: Array as PropType<OptionsProps[]>,
      default() {
        return [];
      },
    },
  },
  setup(__props) {

  
  const appStore = useAppStore();
  const handleChange = async ({
    key,
    value,
  }: {
    key: string;
    value: unknown;
  }) => {
    if (key === 'colorWeak') {
      document.body.style.filter = value ? 'invert(80%)' : 'none';
    }
    if (key === 'menuFromServer' && value) {
      await appStore.fetchServerMenuConfig();
    }
    appStore.updateSettings({ [key]: value });
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h5", _hoisted_2, _toDisplayString(__props.title), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
      return (_openBlock(), _createElementBlock("div", {
        key: option.name,
        class: "switch-wrapper"
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t(option.name)), 1),
        _createVNode(FormWrapper, {
          type: option.type || 'switch',
          name: option.key,
          "default-value": option.defaultVal,
          onInputChange: handleChange
        }, null, 8, ["type", "name", "default-value"])
      ]))
    }), 128))
  ]))
}
}

})